import { useContext } from 'react';
import { StyleContext } from '../../providers/StyleContextProvider';
import { JobApplication } from '../../models/JobApplication';
import { ReactComponent as Calender } from '../../assets/svg/calendar.svg';
import { FeedbackCard } from '../Shared/FeedbackCard';
import { formatDateWithSuperscript } from '../../helpers/Common';

interface Props {
    jobApplications: JobApplication[];
}

export const JobApplicationsTab: React.FC<Props> = (props) => {
    const styleContext = useContext(StyleContext);
    const tabStyles = styleContext.getComponentStyle("candidatePoolTabs");
    const styles = tabStyles.jobApplicationsTab; 

    return (
        <>
            <div style={styles.content}>
                <p style={styles.title}>Applications</p>
                {(props.jobApplications && props.jobApplications.length > 0) ? (
                    props.jobApplications?.map((application) => (
                        <div style={styles.jobApplication}>
                            <div style={styles.jobApplication.recordInfo}>
                                <Calender style={styles.jobApplication.calendarIcon}/>
                                <div style={styles.jobApplication.detailsWrapper}>
                                    <div style={styles.jobApplication.details}>
                                        {formatDateWithSuperscript(application.createdDate)} - {application.job?.organization?.organizationName + "/" + application.applicationStatus?.status}
                                    </div>
                                </div>
                            </div>  
                            <div style={styles.jobApplication.jobTitle}>{application.job?.jobTitle}</div>
                        </div>
                    ))) : 
                    <FeedbackCard
                        styles={styles.noCandidates}
                        message={`There are no Applications available.`}
                    />
                }
            </div>
        </>
    );
}